import axios from "axios";
import { APP_BASE_URL } from "./storage";
import { changeAccessToken } from "../actions/token";
import store from "../store";
import { saveClientId } from "../actions/appConfig";
import { Alert } from "react-native";

const API = axios.create({
  baseURL: APP_BASE_URL,
});

API.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const {
      token: { accessToken },
    } = store.getState();
    if (accessToken && config.url !== `${APP_BASE_URL}/v2/profile/token`)
      config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

let isAlreadyFetchingAccessToken = false;
let isAlreadyReturnGlobalError = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter((callback) => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback); // add request queue
}

const bypassRefresh = (originalRequest) => {
  if (
    originalRequest.url.includes("v1/users/refresh") ||
    originalRequest.url.includes("/login") ||
    originalRequest.method === "delete"
  ) {
    return true;
  }
  return false;
};

// intercept if token expired,then extend
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error || !error.response) {
      if (!isAlreadyReturnGlobalError) {
        isAlreadyReturnGlobalError = true;
        setTimeout(() => {
          isAlreadyReturnGlobalError = false;
        }, 10000);
      }
    }

    const {
      config,
      response: { status },
    } = error;
    const originalRequest = config;

    if (
      status === 401 &&
      originalRequest.method !== "delete" &&
      !bypassRefresh(originalRequest)
    ) {
      console.log("try reauth");
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;

        console.log("reauth processing");
        API.post(
          `${APP_BASE_URL}/v2/profile/token`,
          {},
          {
            headers: {
              Authorization: `Bearer ${store.getState().token.token}`,
            },
          }
        )
          .then(({ data: { access_token, metadata } }) => {
            isAlreadyFetchingAccessToken = false;

            const newTokenBearer = `Bearer ${access_token}`;
            const newAccessToken = access_token;
            console.log("reauth success, save new token");
            store.dispatch(changeAccessToken(newAccessToken));
            store.dispatch(saveClientId(metadata.client_id));

            API.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
            originalRequest.headers.Authorization = newTokenBearer;

            onAccessTokenFetched(newAccessToken);
          })
          .catch((error) => {
            console.log(error?.response || error);
            Alert.alert(
              "Gagal Login",
              "Terjadi kesalahan sistem, mohon untuk mengulang proses beberapa saat lagi.",
              [{ text: "OK" }],
              { cancelable: false }
            );
          });
      }

      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber((access_token) => {
          console.log("try request again");
          store.dispatch(changeAccessToken(access_token));
          originalRequest.headers.Authorization = "Bearer " + access_token;
          resolve(axios(originalRequest));
        });
      });
      return retryOriginalRequest;
    }

    if (status === 429) {
      return axios(originalRequest);
    }

    return Promise.reject(error);
  }
);

export { API, axios };
